import React from 'react';
import autobind from 'autobind-decorator';
import {Col, Row} from 'react-bootstrap';
import {Glyphicon} from "../GlyphIcon";

import * as builtInViewers from '../../../Models/Core/FieldViewers';

import * as serviceDrivenViewers from '../../../Models/Core/ServiceDrivenViewers';
import {ObjectUtils} from "../../../Utils";

export class ActivityFeedValueDeltaDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayOld: false
        }
    }

    @autobind
    togglePreviousView() {
        this.setState({
            displayOld: !this.state.displayOld
        });
    }

    @autobind
    renderValue(value, data, fieldCustomData) {
        if(this.props.Viewer) { //Ehh I don't like filtering on startsWith viewers. (but I can't think of a better way.)
            const customViewerStr = "viewers.";
            const serviceDrivenViewerStr = "viewers.ServiceDrivenFieldViewer";
            const viewerName = this.props.Viewer.substring(customViewerStr.length);

            if (this.props.Viewer.startsWith(serviceDrivenViewerStr)) {
                // Get service name between parenthesis
                const serviceName = viewerName.substring( viewerName.indexOf( '(' ) + 1, viewerName.indexOf( ')' ) );
                const ServiceDrivenViewer = serviceDrivenViewers[serviceName + 'Viewer'];
                if(!ServiceDrivenViewer) { 
                    console.log('Undefined ServiceDrivenViewer:', serviceName + 'Viewer');
                    return "N/A";
                }
                return <ServiceDrivenViewer
                    Value={value}
                    Data={data}
                    FieldCustomData={fieldCustomData}
                />;
            // } else if(this.props.Viewer.startsWith(customViewerStr)) {
            //     if(viewers[viewerName]) {
            //         let dynamic = {
            //             component: viewers[viewerName]
            //         };
            //         return <dynamic.component
            //             Value={value}
            //             Data={data}
            //             FieldCustomData={fieldCustomData}
            //         />;
            //     }
            } else {
                if(builtInViewers[this.props.Viewer]) {
                    let dynamic = {
                        component: builtInViewers[this.props.Viewer]
                    };
                    return <dynamic.component
                        Value={value}
                        Data={data}
                        FieldCustomData={fieldCustomData}
                    />;
                }
            }
        } else if(ObjectUtils.IsString(value)) {
            return value;
        }

        console.log('bad Delta Field value', value);
        return "N/A";
    }

    render() {
        let rootDivClasses = "sb-activity-feed-delta-value-display";

        if(this.props.FieldKey) {
            rootDivClasses += " sb-activity-feed-field-key-" + this.props.FieldKey;
        }

        if (!this.props.OldValue) {
            return <Row className={rootDivClasses}>
                <Col xs={12} className="sb-activity-feed-delta-value-display-new-value">
                    {this.renderValue(this.props.NewValue, this.props.NewData, this.props.FieldCustomData)}
                </Col>
            </Row>;
        } else if (!this.props.NewValue) {
            return <Row className={rootDivClasses}>
                <Col xs={12} className="sb-activity-feed-delta-value-display-old-value">
                    {this.renderValue(this.props.OldValue, this.props.OldData, this.props.FieldCustomData)}
                </Col>
            </Row>;
        } else {
            return <Row className={rootDivClasses}>
                <Col xs={12} className="sb-activity-feed-delta-value-display-new-value">
                    {this.renderValue(this.props.NewValue, this.props.NewData, this.props.FieldCustomData)}
                </Col>
                <Col xs={12} className="sb-activity-feed-delta-value-display-button">
                    <a className="float-right" onClick={this.togglePreviousView}>
                        <Glyphicon glyph="file" /> {this.state.displayOld ? "Hide Previous": "View Previous"}
                    </a>
                </Col>
                {
                    this.state.displayOld ?
                        <Col xs={12} className="sb-activity-feed-delta-value-display-old-value">
                            {this.renderValue(this.props.OldValue, this.props.OldData, this.props.FieldCustomData)}
                        </Col> :
                        null
                }
            </Row>;
        }
    }
}


